import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import routeConfiguration from '../../../routeConfiguration';
import { createResourceLocatorString } from '../../../util/routes';
import BoxSeparator from '../../BoxSeperator/BoxSeparator';
import Link from '../../Links/Link/Link';

const buttonLinkStyle = { justifyContent: 'space-between' };
const couponLink = 'https://shop.vansite.eu/products/vansite-gutschein';

const SectionPassProductsComponent = ({ onClose }) => {
  const intl = useIntl();

  return intl.locale === 'de' ? (
    <>
      <BoxSeparator />
      <Stack px={4}>
        <Typography gutterBottom variant="h5">
          <FormattedMessage id="AccountBottomBarBox.productsHeader" />
        </Typography>

        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: 'pass', rest: 'jahrespass' },
            {},
            intl.locale,
          )}
        >
          <FormattedMessage id="TopbarDesktop.annualPassHeader" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: 'pass', rest: '25pass' },
            {},
            intl.locale,
          )}
        >
          <FormattedMessage id="TopbarDesktop.25pass" />
          <ChevronRightIcon color="secondary" />
        </Button>
        <Button
          color="secondary"
          component={Link}
          fullWidth
          href={couponLink}
          onClick={onClose}
          sx={buttonLinkStyle}
          target="_blank"
        >
          <FormattedMessage id="TopbarDesktop.vansiteCoupon" />
          <ChevronRightIcon color="secondary" />
        </Button>
      </Stack>
    </>
  ) : null;
};

SectionPassProductsComponent.displayName = 'SectionPassProducts';
const SectionPassProducts = memo(SectionPassProductsComponent);
export default SectionPassProducts;
